import { createContext } from 'react'

export type HeaderFlags = {
  isBrandRefresh: boolean
  isBlackFriday: boolean
  isBlackFridayPrereg: boolean
}

export const HEADER_FLAGS_OFF: HeaderFlags = {
  isBrandRefresh: false,
  isBlackFriday: false,
  isBlackFridayPrereg: false,
}

const HeaderFlagsContext = createContext<HeaderFlags>(HEADER_FLAGS_OFF)

export default HeaderFlagsContext
